export default __webpack_public_path__ + "static/media/logo_ntv.e1f4938f.svg";